'use strict';
import angular from 'angular';
import './scripts/products.ctrls';
import './scripts/products.services';
import '../../scripts/shared/formFields.directives';

import productsHtmlUrl from './views/products.html';
import viewProductGroupsHtmlUrl from './views/viewProductGroups.html';
import productLookupsHtmlUrl from './views/ProductLookups.html';
import viewProductFlightsHtmlUrl from './views/viewProductFlights.html';


angular.module('products', [
    'products.ctrls',
    'products.services',
    'formFields.directives'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('products', {
                parent: 'layout',
                url: '/admin/products',
                templateUrl: productsHtmlUrl,
                controller: 'ProductsController'
            })
            .state('viewProductGroups', {
                parent: 'layout',
                url: '/admin/productGroups/:id',
                templateUrl: viewProductGroupsHtmlUrl,
                controller: 'ViewProductGroupsController',
                params: {
                    product: null,
                    message: null
                }
            })
            .state('productLookup', {
                parent: 'layout',
                url: '/admin/productLookup/:id',
                templateUrl: productLookupsHtmlUrl,
                controller: 'ProductLookupController'
            })
            .state('productFlights', {
                parent: 'layout',
                url: '/admin/productFlights/:id/:flightFormId/:productName',
                templateUrl: viewProductFlightsHtmlUrl,
                controller: 'ProductFlightsController',
            })
    }]);